import * as _hammerjs from 'hammerjs';

export const hammerjs = _hammerjs;
